import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const bannerDefaultVariants = {}
const bannerCompoundVariants = []

const bannerSlotNames = [
  [
    "root",
    "Banner__root"
  ],
  [
    "overlay",
    "Banner__overlay"
  ],
  [
    "text",
    "Banner__text"
  ],
  [
    "content",
    "Banner__content"
  ],
  [
    "title",
    "Banner__title"
  ],
  [
    "image",
    "Banner__image"
  ]
]
const bannerSlotFns = /* @__PURE__ */ bannerSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, bannerDefaultVariants, getSlotCompoundVariant(bannerCompoundVariants, slotName))])

const bannerFn = memo((props = {}) => {
  return Object.fromEntries(bannerSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const bannerVariantKeys = []
const getVariantProps = (variants) => ({ ...bannerDefaultVariants, ...compact(variants) })

export const banner = /* @__PURE__ */ Object.assign(bannerFn, {
  __recipe__: false,
  __name__: 'banner',
  raw: (props) => props,
  variantKeys: bannerVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, bannerVariantKeys)
  },
  getVariantProps
})